import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ACTUATOR_INFO_URL } from '../app.config';

export interface App {
  name: string;
  description: string;
  version: string;
}

export interface Info {
  app: App;
}

@Injectable()
export class InfoService {

  constructor(private http: HttpClient) {
  }

  getInfo(): Observable<Info> {
    return this.http
    .get<Info>(ACTUATOR_INFO_URL, {
      observe: 'response',
      responseType: 'json',
      headers: { 'Accept': '*/*' }
    }).pipe(
      map((response) => response.body));
  }
}
